import { render, staticRenderFns } from "./PurchaseOrderListView.vue?vue&type=template&id=27cb2ad5"
import script from "./PurchaseOrderListView.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports